<template>
  <b-modal id="bv-modal-addOrSubtract">
    <template #modal-header>
      <h4>{{ type ? $t("add_quantity") : $t("subtract_quantity") }}</h4>
      <b-button
        size="sm"
        variant="outline-light"
        class="ml-auto"
        @click="$bvModal.hide('bv-modal-addOrSubtract')"
      >
        <i class="fas fa-times"></i>
      </b-button>
    </template>
    <div>
      <b-input-group class="mt-3">
        <b-button variant="success" @click="quantity += 1"
          ><i class="fas fa-plus"></i
        ></b-button>
        <input
          type="number"
          min="1"
          v-model="quantity"
          class="text-center ml-2 mr-2 form-control"
          :placeholder="$t('quantity')"
        />
        <b-button
          :disabled="quantity < 1 ? true : false"
          variant="danger"
          @click="quantity = quantity - 1"
          ><i class="fas fa-minus"></i
        ></b-button>
      </b-input-group>
    </div>

    <template #modal-footer>
      <b-button size="sm" variant="primary" @click="updateInventory">
        {{ $t("save") }}
      </b-button>
      <b-button
        size="sm"
        variant="secondary"
        @click="$bvModal.hide('bv-modal-addOrSubtract')"
      >
        {{ $t("close") }}
      </b-button>
    </template>
  </b-modal>
</template>
<script>
import { mapActions } from "vuex";
export default {
  data() {
    return {
      type: 0,
      product_id: 0,
      inventory_id: 0,
      quantity: 0,
      warehouse_id: 0,
    };
  },
  watch: {
    quantity() {
      this.quantity < 0 ? (this.quantity = 0) : "";
    },
  },
  methods: {
    ...mapActions({
      addOrsubtract: "inventory/addOrSubtractInventary",
      getInventoryByProduct: "inventory/showInventory",
    }),
    showModal(item) {
      (this.quantity = 0),
        (this.type = item.type),
        (this.product_id = item.res.inventory.product_id);
      this.inventory_id = item.res.inventory_id;
      this.warehouse_id = item.res.warehouse_id;
      this.$bvModal.show("bv-modal-addOrSubtract");
    },
    async updateInventory() {
      let payload = {
        inventory_id: this.inventory_id,
        product_id: this.product_id,
        quantity: this.quantity,
        warehouse_id: this.warehouse_id,
      };
      await this.getInventoryByProduct(this.$route.params.id);
      await this.addOrsubtract({ type: this.type, payload: payload });
      this.$bvModal.hide("bv-modal-addOrSubtract");
    },
  },
};
</script>

<style></style>
